module.exports = __webpack_public_path__ + "img/hotzxbanner_sample.87fa5c04.png";